import React from "react";
import { Dialog, DialogContent, Box, Typography, Button, useMediaQuery } from "@mui/material";
import theme from "../../util/theme/theme";

export interface CategoryTaxConfirmPopupProps {
    open: boolean;
    currentTaxNames: string[];
    newTaxNames: string[];
    onCancel: () => void;
    onCategoryOnly: () => void;
    onCategoryAndTaxes: () => void;
}

const CategoryTaxConfirmPopup: React.FC<CategoryTaxConfirmPopupProps> = ({
    open,
    currentTaxNames,
    newTaxNames,
    onCancel,
    onCategoryOnly,
    onCategoryAndTaxes,
}) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    let contentStyle = { p: 0, pt: 3, pb: 3, px: 4, textAlign: 'center', minWidth: 340 };
    if (isMobile) contentStyle = { p: 2, pt: 3, pb: 3, px: 2, textAlign: 'center', minWidth: 200 };

    const listOrNone = (names: string[]) => names.length > 0 ? names.join(', ') : 'None';

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" PaperProps={{ sx: { borderRadius: isMobile ? 2 : 4, p: 0, overflow: 'hidden' } }}>
            <DialogContent sx={contentStyle}>
                <Typography variant="h6" fontWeight={700} mb={1.5}>
                    Change Category?
                </Typography>
                <Typography color="text.secondary" fontSize={14} mb={2}>
                    This transaction already has taxes applied. The new category has its own default taxes -
                    do you want to replace the applied taxes to match it, or only change the category?
                </Typography>
                <Box sx={{ textAlign: 'left', border: '1px solid #e0e0e0', borderRadius: 2, p: 1.5, mb: 3, background: 'var(--color-container-background)' }}>
                    <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                        <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: 'var(--color-text-muted)', width: 110, flexShrink: 0 }}>
                            Applied now:
                        </Typography>
                        <Typography sx={{ fontSize: 12.5, color: 'var(--color-default-text)' }}>
                            {listOrNone(currentTaxNames)}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: 'var(--color-text-muted)', width: 110, flexShrink: 0 }}>
                            New category default:
                        </Typography>
                        <Typography sx={{ fontSize: 12.5, color: 'var(--color-primary)', fontWeight: 600 }}>
                            {listOrNone(newTaxNames)}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={onCategoryAndTaxes}
                        sx={{ borderRadius: 2, fontWeight: 600, py: 1.1, boxShadow: 'none', textTransform: 'none', background: 'var(--color-primary)', color: '#fff', '&:hover': { background: 'var(--color-primary)' } }}
                    >
                        Change Category &amp; Taxes
                    </Button>
                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={onCategoryOnly}
                        sx={{ borderRadius: 2, fontWeight: 600, py: 1.1, textTransform: 'none' }}
                    >
                        Change Category Only
                    </Button>
                    <Button
                        variant="text"
                        fullWidth
                        onClick={onCancel}
                        sx={{ borderRadius: 2, fontWeight: 600, py: 1.1, textTransform: 'none', color: 'var(--color-text-muted)' }}
                    >
                        Cancel
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default CategoryTaxConfirmPopup;
